<template>
  <div class="grid">
    <div :class=" ( !isLoading) ? 'grid-body pb-0' : 'grid-body'">
      <v-row align="center" class="p-3">
        <v-col cols="3">
          <v-text-field
            v-model="paging.name"
            v-on:keyup="search()"
            :label="$t('_LIST_USER.SEARCH_PLACEHOLDER')"
            class="mt-0 pt-0"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-autocomplete :label="$t('_EDIT_USER.GROUP')" outlined dense item-text="text" item-value="value" :items="listGroup" v-on:change="search()"
                  v-model="paging.group"></v-autocomplete>
        </v-col>
        <v-col sm="4" class="pt-0">
          <v-radio-group v-model="paging.active" row class="" @change="search()">
            <v-radio
              :label="$t('ALL')"
              :value="null"
            ></v-radio>
            <v-radio
              :label="$t('ACTIVE')"
              :value=1
            ></v-radio>
            <v-radio
              :label="$t('DEACTIVE')"
             :value=0
            ></v-radio>
          </v-radio-group>
        </v-col>
        <v-col class="text-right">

          <v-btn @click="addUser" color="primary" class="pl-10 pr-10">
            <v-icon dark>
              mdi-plus
            </v-icon>
            {{$t('ADD_NEW')}}
          </v-btn>
        </v-col>
      </v-row>

      <v-progress-linear
        color="warning"
        indeterminate
        rounded
        height="3"
        v-if="isLoading"
      ></v-progress-linear>

      <v-data-table
        :headers="headers"
        :items="data"
        :items-per-page="15"
        disable-sort
        hide-default-footer
        item-key="username"
        v-if="!isLoading"
        class="table-user"
      >
        <!-- Row items -->
        <template slot="no-data">
          <span>{{$t("HAS_NO_DATA")}}</span>
        </template>
        <template v-slot:item.userGroup="{ item }">
          <span style="font-weight: 500;">{{item.userGroup}}</span>
        </template>
        <template v-slot:item.userName="{ item }">
          {{item.userName}}
        </template>
        <template v-slot:item.fullName="{ item }">
          {{item.fullName}}
        </template>
        <template v-slot:item.email="{ item }">
          {{item.email}}
        </template>
        <template v-slot:item.createdBy="{ item }">
          {{item.createdBy}}
        </template>
        <template v-slot:item.createdDate="{ item }">
          {{formatDateTime(item.createdDate, 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY HH:mm')}}
        </template>
        <template v-slot:item.active="{ item }">
            <div
              v-if="!item.active"
              class="status-deactived not-active"
            >{{$t('_LIST_USER.STATUS_DEACTIVATE')}}</div>
            <div
              v-if="item.active"
              class="status-actived active"
            >{{$t('_LIST_USER.STATUS_ACTIVATE')}}</div>
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip top transition="slide-y-reverse-transition">
            <template v-if="item.userName != currentUsername" v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                @click="editUser(item)"
                x-small
                class="rounded-sm mr-1"
                v-bind="attrs"
                v-on="on"
                color="accent"
              >
                <v-icon size="15">
                  mdi-pencil
                </v-icon>
              </v-btn>
            </template>
            {{ $t("EDIT") }}
          </v-tooltip>
          <v-tooltip top transition="slide-y-reverse-transition">
            <template v-if="item.userName != currentUsername" v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                color="error"
                @click="openDialogDeleteUser(item)"
                x-small
                v-bind="attrs"
                v-on="on"
                class="rounded-sm"
              >
                <v-icon size="15">
                  delete
                </v-icon>
              </v-btn>
            </template>
            {{ $t("DELETE") }}
          </v-tooltip>
        </template>
      </v-data-table>
      <paging v-if="paging && paging.total" :paging.sync="paging" @changePage="changePage" class="pr-3">
        <span slot="totalItems">{{$t("TOTAL")}}: {{paging.total}} {{$t("_LIST_USER.USER")}}</span>
      </paging>

      <!-- Delete user dialog -->
      <v-dialog v-model="deleteUserDialog" max-width="260" content-class="dialog-confirm">
        <v-toolbar class="toolbar-update" dense >
          <v-toolbar-title class="text-primary fs-15">
            <strong>{{$t('NOTIFICATION')}}</strong>
          </v-toolbar-title>
        </v-toolbar>
        <div class="content-update">
          <label class="s-label">
            <span v-if="isCurrentUser">{{ $t('_LIST_USER.CANNOT_DELETE_CURRENT_USER') }}</span>
            <span v-else>{{$t('_LIST_USER.REMOVE')}}</span>
          </label>
          <div class="mt-3 d-flex justify-content-between">
            <div class="w-100 mr-1">
              <v-btn depressed block @click="deleteUserDialog = false">
                {{ $t("_LOGIN.CANCEL") }}
              </v-btn>
            </div>
            <div class="w-100 ml-1">
              <v-btn block color="error" @click="deleteUser" v-if="!isCurrentUser">
                {{ $t("DELETE") }}
              </v-btn>
            </div>
          </div>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Paging from "@/components/Utils/Paging.vue";
import { LIMIT_AND_OFFSET } from "@/_helpers/config.js";
import { _alert, _formatDateTime } from "@/_helpers/function.js";
import { service } from "@/_services/Account/ManageUser/manage-user.service.js";
import debounce from "lodash.debounce";
import { authenticationService } from "@/_services";

export default {
  components: {
    paging: Paging
  },
  data() {
    return {
      listGroup: [],
      currentUsername:
        authenticationService.currentUserValue.user.username || {},
      isCurrentUser: false,
      isLoading: false,
      headers: [
        {
          text: this.$t("_LIST_USER.GROUP_NAME"),
          align: "left",
          value: "userGroup"
        },
        {
          text: this.$t("_LIST_USER.USERNAME"),
          align: "left",
          value: "userName"
        },
        {
          text: this.$t("_LIST_USER.NAME"),
          align: "left",
          value: "fullName"
        },
        {
          text: this.$t("_LIST_USER.EMAIL"),
          align: "left",
          value: "email"
        },
        // {
        //   text: this.$t("_LIST_USER.CREATE_USER"),
        //   align: "left",
        //   value: "createdBy",
        //   width: "10%"
        // },
        {
          text: this.$t("_LIST_USER.CREATE_DATE"),
          align: "left",
          value: "createdDate",
          width: "15%"
        },
        {
          text: this.$t("_LIST_USER.STATUS"),
          align: "left",
          value: "active",
          width: "15%"
        },
        {
          text: this.$t("_LIST_USER.ACTION"),
          align: "center",
          value: "action",
          width: "10%"
        }
      ],
      data: [],
      paging: {
        total: 0,
        limit: 15,
        offset: 0,
        name: "",
        group: '',
        active: null
      },
      currentUser: null,
      deleteUserDialog: false
    };
  },
  created() {
    this.initialize();
  },
  methods: {
   async getGroup() {
        await service.getAllActiveUserGroup({ name: "" }).then(res => {
        // this.listAllGroups = res.data;
        this.listGroup = res.data.map(
          x => {
            return {
              value: x.id,
              text: x.groupName
            };
          }
        );
        this.listGroup = this.listGroup.filter(
          x => x.value
        );
        this.getAll()
      });
    },
  
    search: debounce(function(value) {
      this.getAll();
    }, 300),
    formatDateTime(value, inputFormat, outputFormat) {
      return _formatDateTime(value, inputFormat, outputFormat);
    },
    // Run when start
    initialize() {
      // Call service
      this.getGroup();
    },
    // Change page
    changePage(paging) {
      this.paging = paging;
      this.getAll();
    },
    // Get all user
    getAll() {
      this.isLoading = true;
      let request = {
        name: this.paging.name,
        limit: this.paging.limit,
        offset: this.paging.offset,
        group: this.paging.group,
        active: this.paging.active
      }
      service
        .getAllUser(request)
        .then(res => {
          if (res.responseCode === 0) {
            this.paging.total = res.total;
            this.data = res.data;
          }
        })
        .finally(() => (this.isLoading = false));
    },
    addUser() {
      this.$router.push({ name: "addUser" });
    },
    editUser(item) {
      this.$router.push({ name: "editUser", params: { id: item.id } });
    },
    openDialogDeleteUser(item) {
      if (item.userName == this.currentUsername) {
        this.isCurrentUser = true;
      } else {
        this.isCurrentUser = false;
      }
      this.deleteUserDialog = true;
      this.currentUser = item;
    },
    deleteUser() {
      this.deleteUserDialog = false;
      if (!this.currentUser) {
        return;
      }
      this.isLoading = true;
      service
        .deleteUser(this.currentUser.id)
        .then(res => {
          if (res.responseCode === 0) {
            this.initialize();
          }
          _alert(res, this.$t(res.data), false);
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>